import React from 'react';
import '../Styles/BandHunt.css';
import { Container } from 'react-bootstrap';
import TitleTH from "../Assets/BandHunt/tomorrowHeadliners.png";
import Infographic from "../Assets/BandHunt/Infographic.png";

function BandHunt() {

    return (
        <div>
            <section className='infographicBlock'>
                <div className='centerBh'>
                    <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" src={TitleTH} className="titleThImg" alt='Tomorrows headliners independence rock'></img>
                    <br></br>
                    <img data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" src={Infographic} className="infographicBh" alt='Band hunt independence rock'></img>
                    <div className='txtBandHunt'>
                        <h1 data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='HeadingBandHunt'>Want to be the band that kicks off I-Rock? You should.</h1>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>
                            Presenting Tomorrow’s Headliners - The band hunt for India’s next rock legends.
                            <br></br>
                            If you’re a young rock or metal band who’s dreaming big, we’re giving you the chance to take the stage at Mahindra Independence Rock and perform for thousands of the country's most devoted rock fans and metalheads.
                            <br></br>
                            Since 1986, I-Rock has been taking young bands they thought more people should know and turning them into rock legends.
                            <br></br>
                            <br></br>
                            Some of the biggest bands started their journey with I-Rock and later became powerhouses that changed the Indian music scene; they were a group of inexperienced chaps jamming their hearts out, determined to keep going.
                            Independence Rock catapulted them to the centre stage, and they’ve stayed there ever since, and now it's your turn to grab the opportunity!
                            <br></br>
                            So, bring those riffs out of the bedroom and lyrics out of a notebook to the stage where they belong.
                            <br></br>
                            Let’s get started.
                            <br></br> <br></br>
                            Register here with your band details once you have done the following:
                            Post a performance video on Instagram.

                            * Use the hashtag #TomorrowsHeadliners.
                            <br></br>
                            * Tag us @independencerock
                            <br></br>
                            * Practice your stage moves because you could be selected to share the stage with Avial, Zero, Thaikuddam Bridge, Bloodywood, The F16s, and more.
                            <br></br>
                            * Last date for entries will be 14th October 2022.
                            <br></br>
                            <span className='highlightBh'>Please ensure to read the rules and regulations below to ensure your submission is valid.</span>
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='subhHeadBh'>RULES AND REGULATIONS</h2>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>* Upload a performance video of 2 – 5 minutes to Instagram. This can be either a cover or an original track.
                            <br></br>
                            * Your performance video must be recent. We will only consider entries uploaded on or after 1st January 2022.
                            <br></br>
                            * The lyrics of the songs being performed will also need to be submitted while filling your registration form.
                            <br></br>
                            * The IG profile on which your performance video is being uploaded to, needs to be open to public viewing.
                            <br></br>
                            * Please do ensure the relevant accounts are tagged - @independencerock and the right hashtags are being used when uploaded your video - #TomorrowsHeadliners. Entries without the right tags and hashtags will be considered invalid.
                            <br></br>
                            * Languages allowed – All languages spoken in India (lyrics to be shared in English text)
                            <br></br>
                            * Judging Criteria: up to judge’s discretion </p>
                        <h2 data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='subhHeadBh'>WHAT HAPPENS NEXT?</h2>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>Once we have the final scores from our judges, we will announce the top 3 bands that will move onto the final round of the band hunt.
                            <br></br>
                            The top 3 shortlisted bands will then have 72 hours from the time of the announcement to upload their entry on Instagram as a collaborative post with @independencerock
                            <br></br>
                            Judging Criteria: up to judge’s discretion</p>
                        {/* faq */}
                        <h2 data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='subhHeadBh'>FAQs</h2>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>1. When do registrations close?
                            <br></br>
                            A. Last date for submission is 14th October 2022. There is no sign-up fee.
                        </p>

                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>2. Can the performance video be a submission of cover or original or original track?
                            <br></br>
                            A. Your performance can be a submission or either a cover or original track.
                            <br></br>
                            If you qualify to the Top 3, you will need to submit an entry which will need to be a performance of an original track.
                        </p>

                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>3. How many entry videos can I submit?
                            <br></br>
                            A. ONLY 1
                        </p>
                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>4. Will my entry video be used by Independence Rock?
                            <br></br>
                            A. By submitting your video, you agree that your video can potentially be used in the promotion of Mahindra Independence Rock.
                        </p>

                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>5. How old do I need to be to participate?
                            <br></br>
                            A. You must be 16 years old or above to participate in the competition.
                        </p>

                        <p data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in" className='paraBandHunt'>6. I registered but haven’t received my confirmation email. What should I do?
                            <br></br>
                            A. rocknroll@independencerock.in
                        </p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default BandHunt